'use client';

import { type ComponentProps, type ReactNode } from 'react';
import Link from 'next/link';

import { track } from '@/lib/analytics';
import { Button } from '@/components/ui/button';

type ButtonProps = ComponentProps<typeof Button>;

/**
 * A CTA that renders as a styled Button+Link and fires the `cta_click`
 * PostHog event. Lets otherwise-static sections keep the analytics event
 * without turning the whole section into a client component.
 */
export function CtaLink({
  href,
  event,
  children,
  variant = 'brand',
  size = 'xl',
  className,
  target,
  rel,
}: {
  href: string;
  event: Record<string, unknown>;
  children: ReactNode;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  className?: string;
  target?: string;
  rel?: string;
}) {
  return (
    <Button asChild size={size} variant={variant} className={className}>
      <Link href={href} target={target} rel={rel} onClick={() => track('cta_click', event)}>
        {children}
      </Link>
    </Button>
  );
}
